import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";

// Fullscreen viewer for a tapped chat photo - same portal-to-#react-root /
// transparent-stage pattern as GiftViewerDialog.tsx, but deliberately
// simpler: no consuming-on-close, no heart clip, just the full-resolution
// image. `src` is resolved by the caller (MessageBubble.tsx) since it
// already knows whether this is a real server attachment (mediaUrl(...),
// needs the current media token) or a still-uploading optimistic message
// (a local blob: URL, which never goes stale and can't be "retried").
const Stage = styled.div`
  background: transparent;
  height: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function ChatMediaViewerDialog({ src, onClose }: { src: string; onClose: () => void }) {
  const [failed, setFailed] = useState(false);
  const [retryKey, setRetryKey] = useState(0);

  return (
    <Dialog
      open
      fullScreen
      onClose={onClose}
      container={() => document.getElementById("react-root")}
      slots={{ paper: Stage }}
      slotProps={{ backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.92)" } } }}
    >
      <IconButton
        aria-label="Back"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 1,
          color: "#fff",
          background: "rgba(255,255,255,0.15)",
          "&:hover": { background: "rgba(255,255,255,0.25)" },
        }}
      >
        <i className="bi bi-arrow-left" />
      </IconButton>

      {failed ? (
        <div style={{ color: "#fff", textAlign: "center" }}>
          <div style={{ marginBottom: 8 }}>Couldn't load this photo.</div>
          <button
            type="button"
            className="btn btn-pink btn-sm"
            onClick={() => {
              setFailed(false);
              setRetryKey((k) => k + 1);
            }}
          >
            Retry
          </button>
        </div>
      ) : (
        <img
          key={retryKey}
          src={src}
          alt="Photo"
          onError={() => setFailed(true)}
          style={{ maxWidth: "95vw", maxHeight: "95vh", objectFit: "contain" }}
        />
      )}
    </Dialog>
  );
}
